const EVENT_BLOCKS = [
  "Details: Drone & Venue Shots::30",
  "Details: Rings,Invitations, & Accessories::20",
  "Details: Dress Shots::10",
  "Bride (Pre-Dress): Bridesmaids Group Shots::10",
  "Bride (Pre-Dress): Bridesmaids Individual Shots::10",
  "Bride (Pre-Dress): Hair & Makeup Details::10",
  "Bride (Pre-Dress): Putting Dress On::10",
  "Bride (Dress On): Accessory Shots::10",
  "Bride (Dress On): Bride Portraits::15",
  "Bride (Dress On): Solo Portraits::15",
  "Groom: Solo Portraits::15",
  "Bride (Dress On): Bridesmaids Group Shots::10",
  "Bride (Dress On): Bridesmaids Individual Shots::10",
  "First Look: with Parent::10",
  "First Look: with Bridesmaids::10",
  "First Look: with Groom::10",
  "Narration: Bride Record Narration::15",
  "Narration: Groom Record Narration::15",
  "Groom: Assisted with Tie & Jacket::10",
  "Groom: Portraits::15",
  "Groom: Groomsmen Group Shots::10",
  "Groom: Groomsmen Individual Shots::10",
  "Ceremony: Audio/Video Setup::20",
  "Ceremony: Average::30",
  "Ceremony: Catholic::60",
  "Group Photos: Family (5 Groups)::20",
  "Group Photos: Family (10 Groups)::45",
  "Wedding Party: Group Shots::15",
  "Bride & Groom: Portraits::20",
  "Bride & Groom: Golden Hour Portraits::20",
  "Reception: Audio/Video Setup::20",
  "Reception: Grand Entrances::10",
  "Reception: Cake Cutting::5",
  "Reception: Bride & Groom Dance::5",
  "Reception: Bride & Parent Dance::5",
  "Reception: Groom & Parent Dance::5",
  "Reception: Special Dance::5",
  "Reception: Dinner::60",
  "Reception: Speeches (Per Speaker)::10",
  "Reception: Open Dance Floor::20",
  "Reception: Garder Belt Toss::15",
  "Reception: Bouquet Toss::15",
];

export { EVENT_BLOCKS };
